var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.719 16.809-4.711-4.711c1.02-1.23 1.582-2.813 1.582-4.536C14.59 3.556 11.285.25 7.277.25 3.234.25 0 3.555 0 7.563c0 4.042 3.27 7.312 7.277 7.312 1.688 0 3.27-.562 4.536-1.582l4.71 4.71a.85.85 0 0 0 .633.247c.211 0 .422-.07.563-.246.351-.317.351-.844 0-1.195M1.687 7.562a5.62 5.62 0 0 1 5.626-5.624c3.093 0 5.625 2.53 5.625 5.625a5.62 5.62 0 0 1-5.626 5.625 5.597 5.597 0 0 1-5.624-5.626"
  })));
};
export default SvgSearch;